import { StaticImage } from "gatsby-plugin-image";
import React, { useEffect, useRef } from "react";

function Modal({
  closeModal,
  modalContent,
  modalContentStyles,
  modalContainerStyles,
  modalOuterContainerStyles,
  modalCloseIcon,
  modalCloseBtnStyles,
  modalCTAButtonStyles
}) {
  const modalWrapperRef = useRef(null);

  function enableScrolling() {
    document
      .getElementsByTagName("html")[0]
      .classList.remove("disable-scrolling");
    document
      .getElementById("mobile-footer-cta")
      .classList.remove("xxxs:hidden");
  }

  function disableScrolling() {
    document.getElementsByTagName("html")[0].classList.add("disable-scrolling");
    document.getElementById("mobile-footer-cta").classList.add("xxxs:hidden");
  }

  useEffect(() => {
    function handleClickOutside(event) {
      if (
        modalWrapperRef.current &&
        !modalWrapperRef.current.contains(event.target)
      ) {
        enableScrolling();
        closeModal();
      }
    }

    disableScrolling();

    // Bind the event listener
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener("mousedown", handleClickOutside);
      enableScrolling();
    };
  }, []);

  return (
    <div className={`modal-outer-container ${modalOuterContainerStyles}`}>
      <div
        className={`modal-container ${modalContainerStyles}`}
        ref={modalWrapperRef}
      >
        <div className={`modal-content ${modalContentStyles}`}>
          <div className={`modal-close-btn ${modalCloseBtnStyles}`}>
            <button
              onClick={() => {
                enableScrolling();
                closeModal();
              }}
              className={`modal-cta-button ${modalCTAButtonStyles}`}
            >
              {modalCloseIcon}
            </button>
          </div>
          {modalContent}
        </div>
      </div>
    </div>
  );
}

export default Modal;
Modal.defaultProps = {
  modalOuterContainerStyles:
    "fixed top-0 bottom-0 left-0 right-0 z-20 flex items-center justify-center w-full h-full modalBackground gvi-modal-bg",
  modalCloseBtnStyles: "flex w-12 h-3",
  modalContainerStyles: "w-9/12 mx-auto",
  modalContentStyles: "w-1/3 mx-auto gvi-light-gray-bg rounded-md py-3",
  modalCTAButtonStyles: "",
  modalCloseIcon: (
    <StaticImage
      src="../../images/close_icon_v2.svg"
      alt="Close Button"
      className="object-contain object-center"
      quality={100}
      layout="fixed"
      width={25}
    />
  )
};
